module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/desktop-app-2-0e669aaaa9dc3c522d327e7d31bcc7fe.png";